import React, { Component } from 'react';
import {
  TableRow,
  TableCell,
  TableHead,
  TableContainer,
  TableBody,
  Table,
} from '@material-ui/core';
import SearchBar from '~/components/SearchBar';
import { T_TitleCell, T_Btn_Function, T_TableRow } from '~/components/TableItem';
import { EAA_Add_Btn } from '~/components/EditAndAddItem';
import T_common from '~/components/TableItem/common';
import DefaultObject from './DefaultObject';
import Detail from './Detail';

class Extend_Additional extends Component {
  state={
    view_Detail: false,
    mode_Detail: '',
    data_num: undefined,
  }

  onAdd=(o = {}) => {
    const { data, onChange } = this.props;
    data.push(o);
    onChange(data);
  }

  onEdit=(o = {}) => {
    const { data, onChange } = this.props;
    const { data_num } = this.state;
    data[data_num] = o;
    onChange(data);
  }

  _add=() => this.setState({ view_Detail: true, mode_Detail: 'add' })
  _view=i => this.setState({ data_num: i, view_Detail: true, mode_Detail: 'view' })
  _edit=i => this.setState({ data_num: i, view_Detail: true, mode_Detail: 'edit' })
  _delete=i => {
    const { data, onChange } = this.props;
    data.splice(i, 1);
    onChange(data);
  }

  _close_Detail=() => this.setState({ data_num: undefined, view_Detail: false, mode_Detail: '' });

  renderTableTitle=() => {
    const ary = [
      { name: '補件次數' },
      { name: '補件原因' },
      { name: '功能' },
    ];
    return (
      <TableHead>
        <TableRow style={{ height: 48 }}>
          {ary.map((o, i) => (
            <T_TitleCell
              key={i}
              text={o.name}
              arrow={!!o.id}
              // bol={sort_field === o.id ? sort : true}
              // onClick={() => onChangeSort(o.id)}
            />
          ))}
        </TableRow>
      </TableHead>
    );
  }

  renderTableBody=() => {
    const { data, disabled } = this.props;
    const cellStyle = { fontSize: 14 };

    const length = data.length;

    return (
      <TableBody>
        {data.map((o, i) => (
          <T_TableRow key={i} backgroundColor= {i % 2 === 0 ? '#E0FDFF' : 'white'}>
            <TableCell align='center' style={cellStyle}>{length - i}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.supple_reason}</TableCell>
            <TableCell style={{ width: 214 }}>
              <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                <T_Btn_Function text='檢視' backgroundColor={T_common.type1} onClick={() => this._view(i)} />
                <T_Btn_Function disabled={disabled} text='編輯' backgroundColor={T_common.type2} onClick={() => this._edit(i)} style={{ marginLeft: 8, marginRight: 8 }} />
                <T_Btn_Function disabled={disabled} text='刪除' backgroundColor={T_common.type3} onClick={() => this._delete(i)} />
              </div>
            </TableCell>
          </T_TableRow>
        ))}
      </TableBody>
    );
  }

  renderTable=() => {
    const { data } = this.props;
    const haveData = data.length > 0;
    return (
      <TableContainer style={{ marginTop: 18, maxWidth: '98%' }}>
        <Table style={{ backgroundColor: 'white', borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
          {this.renderTableTitle()}
          {haveData && this.renderTableBody()}
        </Table>
      </TableContainer>
    );
  }

  render () {
    const { data, disabled, list } = this.props;
    const { view_Detail, mode_Detail, data_num } = this.state;
    const detail_data = !isNaN(data_num) ? data[data_num] : JSON.parse(JSON.stringify(DefaultObject));
    const haveData = data.length > 0;
    return (
      <SearchBar style={{ marginTop: 8 }} text='補件'>
        <EAA_Add_Btn disabled={disabled} onClick={this._add} />
        {this.renderTable()}
        {!haveData && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 30 }}>尚無資料</div>}
        {view_Detail && <Detail mode={mode_Detail} data={detail_data} onChange={o => !isNaN(data_num) ? this.onEdit(o) : this.onAdd(o)} _onClose={this._close_Detail} list={list} />}
      </SearchBar>
    );
  }
}

export default Extend_Additional;
